// Swiper readiness helper — event and frame driven to eliminate CPU blocking
function whenSwiperReady(fn) {
  if (typeof Swiper !== "undefined") {
    fn();
    return;
  }
  var attempts = 0;
  function check() {
    if (typeof Swiper !== "undefined") {
      fn();
    } else if (attempts++ < 60) {
      requestAnimationFrame(check);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      if (typeof Swiper !== "undefined") fn();
      else check();
    }, { once: true });
  } else {
    check();
  }
  window.addEventListener("load", function () {
    if (typeof Swiper !== "undefined") fn();
  }, { once: true });
}

function initSingleFeaturedProductsSlider(sliderContainer) {
  if (!sliderContainer) return;
  if (sliderContainer.classList.contains("sdusa-tab-products-swiper") || sliderContainer.closest(".sdusa-featured-tabs-wrapper")) {
    return;
  }

  if (typeof Swiper === "undefined") {
    whenSwiperReady(function () {
      initSingleFeaturedProductsSlider(sliderContainer);
    });
    return;
  }

  let slides = sliderContainer.querySelectorAll(".swiper-slide");
  let totalSlides = slides.length;
  if (!totalSlides) return;

  const isAutoplay = sliderContainer.dataset.autoplay === "true";
  const autoplaySpeed = parseInt(sliderContainer.dataset.speed) || 4000;
  const requestedDesktopSlides = parseInt(sliderContainer.dataset.slidesPerView, 10) || 4;
  const desktopSlides = Math.min(requestedDesktopSlides, totalSlides);

  const parentSection = sliderContainer.closest(".sdusa-featured-main-wrapper");
  if (!parentSection) return;
  const parentWrapper = sliderContainer.closest(".sdusa-swiper-wrapper-outer") || sliderContainer.parentElement;

  // Dynamically adapt wrapper width & centering based on actual slides count
  if (parentWrapper) {
    if (totalSlides === 1) {
      parentWrapper.style.maxWidth = "340px";
      parentWrapper.style.marginLeft = "auto";
      parentWrapper.style.marginRight = "auto";
      parentWrapper.classList.add("sdusa-single-product-center");
    } else if (totalSlides === 2) {
      parentWrapper.style.maxWidth = "680px";
      parentWrapper.style.marginLeft = "auto";
      parentWrapper.style.marginRight = "auto";
      parentWrapper.classList.add("sdusa-two-products-center");
    } else if (totalSlides === 3 && requestedDesktopSlides >= 3) {
      parentWrapper.style.maxWidth = "1020px";
      parentWrapper.style.marginLeft = "auto";
      parentWrapper.style.marginRight = "auto";
      parentWrapper.classList.add("sdusa-three-products-center");
    }
  }
  const nextEl = parentSection.querySelector(".sdusa-next-btn");
  const prevEl = parentSection.querySelector(".sdusa-prev-btn");

  // Prevent text selection on arrow click
  [nextEl, prevEl].forEach((btn) => {
    if (!btn || btn.dataset.keyboardReady === "true") return;
    btn.dataset.keyboardReady = "true";
    btn.addEventListener("mousedown", (e) => e.preventDefault());
    btn.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        btn.click();
      }
    });
  });

  // Prevent Swiper from sliding when clicking the Cart Button
  const cartButtons = parentSection.querySelectorAll(".sdusa-cart-btn");
  cartButtons.forEach((cartBtn) => {
    if (cartBtn.dataset.stopSwipingReady === "true") return;
    cartBtn.dataset.stopSwipingReady = "true";
    cartBtn.addEventListener("click", (e) => e.stopPropagation());
    cartBtn.addEventListener("pointerdown", (e) => e.stopPropagation());
    cartBtn.addEventListener("touchstart", (e) => e.stopPropagation(), { passive: true });
  });

  // Set stars color to #6e6e6e for products with 0 rating / 0 reviews
  sliderContainer.querySelectorAll(".sdusa-card-rating").forEach((ratingEl) => {
    const starsEl = ratingEl.querySelector(".sdusa-stars");
    const countEl = ratingEl.querySelector(".sdusa-review-count");
    if (!starsEl) return;
    const txt = countEl?.textContent?.trim() || "";
    if (txt === "(0)" || starsEl.dataset.rating === "0" || starsEl.classList.contains("sdusa-stars-zero")) {
      starsEl.style.color = "#6e6e6e";
      starsEl.classList.add("sdusa-stars-zero");
    }
  });

  if (sliderContainer.swiper) {
    sliderContainer.swiper.destroy(true, true);
    sliderContainer.classList.remove("swiper-initialized", "swiper-container-initialized");
  }

  const shouldLoop = isAutoplay && totalSlides > 1;
  const shouldRewind = false;

  // Update arrow disabled state.
  // When Auto Scroll is ON: arrows stay enabled.
  // When Auto Scroll is OFF: disable at first and last slide.
  function updateArrows(swiper) {
    if (!prevEl || !nextEl) return;
    // Swiper can call event handlers before passing the instance in some
    // versions/configurations. Fall back to the instance stored on the
    // slider element and skip safely if it is not ready yet.
    swiper = swiper?.params ? swiper : sliderContainer.swiper;
    const visibleSlides = Number(swiper?.params?.slidesPerView) || 1;
    if (!swiper) return;
    const hasNavigation = shouldLoop || totalSlides > visibleSlides;
    prevEl.style.display = hasNavigation ? '' : 'none';
    nextEl.style.display = hasNavigation ? '' : 'none';
    if (!hasNavigation) return;
    if (shouldLoop) {
      prevEl.classList.remove("swiper-button-disabled");
      nextEl.classList.remove("swiper-button-disabled");
      prevEl.setAttribute("aria-disabled", "false");
      nextEl.setAttribute("aria-disabled", "false");
    } else {
      prevEl.classList.toggle("swiper-button-disabled", swiper.isBeginning);
      nextEl.classList.toggle("swiper-button-disabled", swiper.isEnd);
      prevEl.setAttribute("aria-disabled", swiper.isBeginning ? "true" : "false");
      nextEl.setAttribute("aria-disabled", swiper.isEnd ? "true" : "false");
    }
  }

  const swiperInstance = new Swiper(sliderContainer, {
    slidesPerView: desktopSlides,
    spaceBetween: 20,
    loop: shouldLoop,
    rewind: shouldRewind,
    watchOverflow: false,
    centerInsufficientSlides: true,
    observer: true,
    observeParents: true,
    preventClicks: true,
    preventClicksPropagation: true,
    touchStartPreventDefault: false,
    noSwiping: true,
    noSwipingSelector: ".sdusa-cart-btn",
    autoplay: shouldLoop
      ? { delay: autoplaySpeed, disableOnInteraction: false }
      : false,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
      disabledClass: "swiper-button-disabled",
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 20 },
      576: { slidesPerView: Math.min(desktopSlides, 2), spaceBetween: 20 },
      900: { slidesPerView: Math.min(desktopSlides, 3), spaceBetween: 20 },
      1200: { slidesPerView: desktopSlides, spaceBetween: 20 },
    },
    on: {
      init: function (sw) {
        sliderContainer.classList.add("swiper-initialized", "swiper-container-initialized");
        updateArrows(sw);
      },
      slideChange: updateArrows,
      reachBeginning: updateArrows,
      reachEnd: updateArrows,
      resize: updateArrows,
    },
  });

  sliderContainer.classList.add("swiper-initialized", "swiper-container-initialized");

  const activeSwiper = swiperInstance || sliderContainer.swiper;

  if (isAutoplay && totalSlides > 1 && activeSwiper?.autoplay) {
    activeSwiper.autoplay.start();
  }

  setTimeout(() => {
    if (!activeSwiper) return;
    activeSwiper.update();
    updateArrows(activeSwiper);
  }, 100);
}

function initFeaturedProductsSlider() {
  const sliderContainers = document.querySelectorAll(
    ".sdusa-featured-main-wrapper:not(.sdusa-featured-tabs-wrapper) .sdusa-products-swiper:not(.sdusa-tab-products-swiper)"
  );
  sliderContainers.forEach(initSingleFeaturedProductsSlider);
}

function setupFeaturedProductsObserver() {
  const sections = document.querySelectorAll(
    ".sdusa-featured-main-wrapper:not(.sdusa-featured-tabs-wrapper)"
  );
  if (!sections.length) return;

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            obs.unobserve(entry.target);
            whenSwiperReady(() => {
              const sliders = entry.target.querySelectorAll(
                ".sdusa-products-swiper:not(.sdusa-tab-products-swiper)"
              );
              sliders.forEach(initSingleFeaturedProductsSlider);
            });
          }
        });
      },
      { rootMargin: "300px 0px" }
    );
    sections.forEach((sec) => observer.observe(sec));
  } else {
    whenSwiperReady(initFeaturedProductsSlider);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupFeaturedProductsObserver);
} else {
  setupFeaturedProductsObserver();
}
document.addEventListener("shopify:section:load", initFeaturedProductsSlider);
document.addEventListener("shopify:section:select", initFeaturedProductsSlider);
